module.exports = __webpack_public_path__ + "media/teaser.59148dad.mp4";